import { render, staticRenderFns } from "./detail-tab-transcricao.vue?vue&type=template&id=cb6d2c70&scoped=true&"
import script from "./detail-tab-transcricao.vue?vue&type=script&lang=js&"
export * from "./detail-tab-transcricao.vue?vue&type=script&lang=js&"
import style0 from "./detail-tab-transcricao.vue?vue&type=style&index=0&id=cb6d2c70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d2c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6d2c70')) {
      api.createRecord('cb6d2c70', component.options)
    } else {
      api.reload('cb6d2c70', component.options)
    }
    module.hot.accept("./detail-tab-transcricao.vue?vue&type=template&id=cb6d2c70&scoped=true&", function () {
      api.rerender('cb6d2c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-transcricao/detail-tab-transcricao.vue"
export default component.exports